module.exports = __webpack_public_path__ + "static/media/kid.486453f1.png";